export interface ChangelogItem {
    version: string;
    summary: string[];
    changes: { [key: string]: string[] };
}

export interface ChangelogConfig {
    headlines: { [key: string]: string };
    summary: string;
}
